import type { HelpFile } from '../../types/help'
import { IdentitiesTestIds } from '../../../testids/IdentitiesTestIds'

export const identitiesHelp: HelpFile = {
  docPage: '/docs/identity/identities',
  texts: {
    [IdentitiesTestIds.identitiesList]:
      'Übersicht aller Identitäten — die digitalen Personae, über die Personen oder Agenten Zugriff erhalten.',
    [IdentitiesTestIds.btnNewUser]:
      'Neue Identität anlegen und an eine bestehende Partei knüpfen.',
    [IdentitiesTestIds.identityRow]: null,
    [IdentitiesTestIds.colDisplayName]: null,
    [IdentitiesTestIds.colType]:
      'Klasse der Identität: EMPLOYEE, EXTERNAL, SERVICE oder AGENT.',
    [IdentitiesTestIds.colLifecycleState]:
      'Lebenszyklus-Phase: ACTIVE, INACTIVE oder TERMINATED.',
    [IdentitiesTestIds.colEntryDate]:
      'Beginn der Berechtigung — meist Eintritt oder Vertragsbeginn.',
    [IdentitiesTestIds.colExitDate]:
      'Ende der Berechtigung — meist Austritt oder Vertragsende.',
    [IdentitiesTestIds.colCreatedAt]: null,
  },
}
